<template>
<div class="page_set page">
    <div class="list">
        <div class="list_title">购物指南</div>
        <div class="item" @click="goPage('single-page')">购物流程</div>
        <div class="item" @click="goPage('single-page')">经营证照</div>
        <div class="item" @click="goPage('single-page')">平台资质</div>
        <div class="item" @click="goPage('single-page')">平台资质</div>
        <div class="item" @click="goPage('single-page')">平台资质</div>
        <div class="item" @click="goPage('single-page')">平台资质</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
            show_zhizhao: false // 营业执照弹层
        };
    },
    created: function () {

    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '帮助中心',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
